<template>
  <div class="recommendedList">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.account" placeholder="交易账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.directAccount" placeholder="直接推荐人账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.directPhone" placeholder="直接推荐人手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form. indirectAccount" placeholder="间接推荐人账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.indirectPhone" placeholder="间接推荐人手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
        <el-table-column :label="$t('common.handle')">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">{{$t('common.edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentRecommendedList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'recommendedList',
    data() {
      return {
        form: {
          account: '',
          directAccount: '',
          directPhone: '',
          indirectAccount: '',
          indirectPhone: ''
        },
        tableNav: [
          { name: '交易账号', id: 'account' },
          { name: '客户姓名', id: 'name' },
          { name: '客户手机号', id: 'phone' },
          { name: '开户时间', id: 'ctime' },
          { name: '激活时间', id: 'activeTime' },
          { name: '激活状态', id: 'activeStatuss' },
          { name: '直接推荐人账号', id: 'directAccount' },
          { name: '直接推荐人手机号', id: 'directPhone' },
          { name: '间接推荐人账号', id: 'indirectAccount' },
          { name: '间接推荐人手机号', id: 'indirectPhone' },
          { name: '匹配结果', id: 'matchResultss' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getRecommendedListData(data) {
        nationalMarketing.queryCustomerListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].ctime)) {
                  data[i].ctime = new Date(data[i].ctime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].activeTime)) {
                  data[i].activeTime = new Date(data[i].activeTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].matchResult)) {
                  if (data[i].matchResult == 0) data[i].matchResults = '无推荐人'
                  if (data[i].matchResult == 1) data[i].matchResults = '匹配'
                  if (data[i].matchResult == 2) data[i].matchResults = '不匹配'
                }
                if (Util.isNotEmpty(data[i].activeStatus)) {
                  if (data[i].activeStatus == 0) data[i].activeStatuss = '未激活'
                  if (data[i].activeStatus == 1) data[i].activeStatuss = '已激活'
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initRecommendedListData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getRecommendedListData(data)
      },
      changeCurrentRecommendedList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getClientAccountData(data)
      }
    },
    mounted() {
      this.initRecommendedListData()
    }
  }
</script>

<style lang="scss" scoped>
  .recommendedList {
    margin: 20px;

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
